var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(23 13)",
    d: "M2 12.5V33h14V12.5L9 7.25 2 12.5zM.4 11.2l8-6a1 1 0 0 1 1.2 0l8 6a1 1 0 0 1 .4.8v22a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V12a1 1 0 0 1 .4-.8zM6 30a1 1 0 0 1-2 0V20a1 1 0 0 1 2 0v10zm4 0a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0v6zM9 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4.85-5.276l-1.97-.35C11.96 7.93 12 7.47 12 7c0-2.827-1.449-5-3-5S6 4.173 6 7c0 1.907.672 3.603 1.674 4.458L6.376 12.98C4.895 11.716 4 9.458 4 7c0-3.8 2.133-7 5-7s5 3.2 5 7c0 .587-.05 1.165-.15 1.724z"
  })));
};
export default SvgProducts;